import { CoreExecutorResult } from "../../core/index.js";
import { DataPsmSchema } from "../model/index.js";
import { DataPsmExecutorResultFactory } from "./data-psm-executor-utils.js";
export async function executeDataPsmSetRootCollection(reader, createNewIdentifier, operation) {
    const resource = (await reader.readResource(operation.entityId));
    if (!DataPsmSchema.is(resource)) {
        return DataPsmExecutorResultFactory.invalidType(resource, "data-psm schema");
    }
    const modifiedEntity = {
        ...resource,
        dataPsmCollectionTechnicalLabel: operation.dataPsmCollectionTechnicalLabel,
        dataPsmEnforceCollection: operation.dataPsmEnforceCollection,
    };
    return CoreExecutorResult.createSuccess([], [modifiedEntity]);
}
//# sourceMappingURL=data-psm-set-root-collection-executor.js.map